import { render, staticRenderFns } from "./xwv1.vue?vue&type=template&id=6c90b020&scoped=true"
import script from "./xwv1.vue?vue&type=script&lang=js"
export * from "./xwv1.vue?vue&type=script&lang=js"
import style0 from "./xwv1.vue?vue&type=style&index=0&id=6c90b020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c90b020",
  null
  
)

export default component.exports